<div
  class="w-full h-full flex flex-col bg-white rounded border border-gris-3 relative"
>
  <!-- Header Section -->
  <div class="flex w-full p-3 border-b border-gris-3 gap-3">
    <!-- Title and Create Button -->
    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2"
    >
      <div class="flex items-center">
        <div class="w-8 h-8 bg-vert-1 flex items-center justify-center rounded">
          <app-svg
            class="text-white"
            height="20"
            svgPath="/assets/svg/truck.svg"
            width="20"
          />
        </div>
        <span class="pl-2 text-lg font-semibold">
          {{ 'navbar.tournees' | translate }}
        </span>
      </div>
    </div>

    <div
      class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto ml-auto"
    >
      <div class="relative group w-full sm:w-auto">
        <button
          type="button"
          class="w-full flex items-center justify-center sm:justify-start gap-2 px-3 py-1.5 text-xs font-semibold border border-gris-3 rounded bg-white hover:bg-gris-3 cursor-pointer transition-colors"
        >
          <span class="material-icons !text-md">route</span>
          <span>{{ 'delivery_round.optimize.parent' | translate }}</span>
          <span class="material-icons !text-md">expand_more</span>
        </button>

        <div
          class="group-hover:flex hidden flex-col absolute left-0 top-full w-max bg-white border border-gris-3 rounded shadow z-10"
        >
          <button
            type="button"
            (click)="previewOptimizeSelectedRounds()"
            [disabled]="selectedRounds.length === 0"
            class="flex items-center gap-2 px-3 py-2 text-xs font-semibold text-left transition-colors"
            [class.cursor-pointer]="selectedRounds.length > 0"
            [class.hover:bg-gris-3]="selectedRounds.length > 0"
            [class.cursor-not-allowed]="selectedRounds.length === 0"
            [class.opacity-50]="selectedRounds.length === 0"
          >
            <span class="material-icons !text-md">checklist</span>
            <span>
              {{ 'delivery_round.optimize.selected' | translate }}
              @if (selectedRounds.length > 0) {
                ({{ selectedRounds.length }})
              }
            </span>
          </button>
          <button
            type="button"
            (click)="optimizeAllRounds()"
            class="flex items-center gap-2 px-3 py-2 text-xs font-semibold text-left cursor-pointer hover:bg-gris-3 transition-colors"
          >
            <span class="material-icons !text-md">done_all</span>
            <span>{{ 'delivery_round.optimize.all' | translate }}</span>
          </button>
        </div>
      </div>

      <app-button-cta
        (onClick)="createInlineRound()"
        class="inline-flex w-full sm:w-auto"
        iconType="material"
        label="delivery_round.add"
        svgName="add_circle"
      />
    </div>
  </div>

  @if (!loading) {
    @if (this.responsiveService.isMobile()) {
      <!-- Affichage des tournées sélectionnées version mobile (les unes en dessous des autres) -->
      <div class="flex-1 overflow-y-scroll p-2 space-y-2">
        @for (round of this.deliveryRounds; track round.id) {
          <app-delivery-round-mobile-item
            class="block"
            [round]="round"
            (selectRound)="selectRound($event)"
            (deleteRound)="askToDeleteRound($event)"
            (householdAction)="onHouseholdAction($event)"
            (onRenameRound)="
              this._inputRenameDeliveryRound.setValue($event.name);
              this.renamingRoundId = $event.id;
              validateRenameRound()
            "
          />
        }
      </div>
    } @else {
      <!-- Affichage des tournées sélectionnées version desktop (côte à côte) -->
      <div class="flex-1 flex overflow-hidden">
        <!-- Liste des tournées - 1/4 de la page -->
        <div class="w-1/4 border-r border-gris-3 flex flex-col">
          <div class="pt-4 px-4 pb-2">
            <h2 class="text-base font-semibold text-gray-800">
              {{
                'delivery_round.list'
                  | translate: { total: deliveryRounds.length }
              }}
            </h2>
          </div>

          <div class="flex-1 overflow-y-auto px-4 select-none">
            @if (deliveryRounds.length > 0) {
              @for (round of deliveryRounds; track round.id) {
                <div
                  class="px-3 py-4 mb-2 border-2 rounded cursor-pointer transition-colors bg-gris-4 hover:bg-gray-50 flex items-center shadow"
                  [class.border-gris-3]="!isRoundSelected(round)"
                  [class.selected-round]="isRoundSelected(round)"
                  [class.selected-round-first]="
                    getSelectedRoundIndex(round) === 0
                  "
                  [class.selected-round-second]="
                    getSelectedRoundIndex(round) === 1
                  "
                  (click)="
                    renamingRoundId !== round.id ? selectRound(round) : null
                  "
                >
                  <div class="w-2 h-2 rounded-full bg-vert-1 ml-2 mr-4"></div>

                  @if (renamingRoundId === round.id) {
                    <!-- Mode renommage -->
                    <div class="flex-1 flex items-center gap-2 relative">
                      <input
                        #renameDeliveryRoundInput
                        type="text"
                        (keydown.enter)="
                          _inputRenameDeliveryRound.invalid
                            ? null
                            : validateRenameRound()
                        "
                        (keydown.escape)="cancelRename()"
                        [formControl]="_inputRenameDeliveryRound"
                        [placeholder]="
                          'delivery_round.name_placeholder' | translate
                        "
                        class="min-w-0 flex-1 px-2 py-1 text-sm !border-2 border-gray-300 rounded-md focus:outline-none focus:!border-[#8ABD27]"
                        (click)="$event.stopPropagation()"
                      />

                      <button
                        class="cursor-pointer disabled:cursor-not-allowed p-2 rounded bg-vert-3 border-2 border-vert-1 hover:bg-vert-1 hover:text-white transition-colors group disabled:!bg-gray-200 disabled:!border-gray-300 fg-vert-1 disabled:!text-gray-400 hover:!text-white"
                        [disabled]="_inputRenameDeliveryRound.invalid"
                        (click)="
                          $event.stopPropagation();
                          _inputRenameDeliveryRound.invalid
                            ? null
                            : validateRenameRound()
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="3"
                          stroke="currentColor"
                          class="size-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m4.5 12.75 6 6 9-13.5"
                          />
                        </svg>
                      </button>

                      @if (isRenamingRound) {
                        <div
                          class="fade-in rounded absolute inset-0 bg-black/50 flex items-center justify-center"
                        >
                          <app-loader />
                        </div>
                      }
                    </div>
                  } @else {
                    <!-- Mode normal -->
                    <div class="font-medium -mt-0.5 fg-noir-2-contour flex-1">
                      <span>
                        {{ round.name }}
                      </span>
                      <br />
                      <span class="text-xs font-bold">
                        {{ round.households.length }}
                        {{ 'navbar.foyer_s' | translate | lowercase }}
                      </span>
                    </div>
                    <app-button-cta
                      type="green"
                      class="mr-1"
                      classes="p-1"
                      label=""
                      iconType="material"
                      svgName="edit"
                      (click)="$event.stopImmediatePropagation()"
                      (onClick)="renameRound(round)"
                    />
                    <div class="relative group">
                      <app-button-cta
                        type="red"
                        [active]="round.households.length === 0"
                        classes="p-1"
                        label=""
                        iconType="material"
                        svgName="delete"
                        (click)="$event.stopImmediatePropagation()"
                        (onClick)="askToDeleteRound(round)"
                      />
                      @if (round.households.length > 0) {
                        <div
                          class="hidden fade-in group-hover:block bg-rose-1 rounded p-2 text-white font-semibold text-xs text-center absolute top-full right-0 w-64 z-50"
                        >
                          {{
                            'delivery_round.cannot_remove_if_not_empty'
                              | translate
                          }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            } @else {
              <div
                class="flex items-center justify-center h-full text-gray-500 text-sm px-4 text-center"
              >
                {{ 'delivery_round.no_rounds' | translate }}
              </div>
            }

            @if (this.showInlineDeliveryRoundCreation) {
              <div
                class="relative flex items-center gap-3 px-4 py-3 mb-2 rounded-lg border border-gris-3 bg-gris-4 hover:bg-gray-50 transition-colors"
              >
                <input
                  #createDeliveryRoundInput
                  type="text"
                  (keydown.enter)="
                    _inputInlineDeliveryRoundName.invalid ? null : createRound()
                  "
                  (keydown.escape)="
                    this.showInlineDeliveryRoundCreation = false;
                    this._inputInlineDeliveryRoundName.reset()
                  "
                  [formControl]="_inputInlineDeliveryRoundName"
                  [placeholder]="'delivery_round.name_placeholder' | translate"
                  class="min-w-0 flex-1 py-2 text-sm !border-2 border-gray-300 rounded-md focus:outline-none focus:!border-[#8ABD27]"
                />

                <button
                  class="cursor-pointer disabled:cursor-not-allowed p-2 rounded bg-vert-3 border-2 border-vert-1 hover:bg-vert-1 hover:text-white transition-colors group disabled:!bg-gray-200 disabled:!border-gray-300 fg-vert-1 disabled:!text-gray-400 hover:!text-white"
                  [disabled]="this._inputInlineDeliveryRoundName.invalid"
                  (click)="
                    this._inputInlineDeliveryRoundName.invalid
                      ? null
                      : createRound()
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="3"
                    stroke="currentColor"
                    class="size-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m4.5 12.75 6 6 9-13.5"
                    />
                  </svg>
                </button>

                @if (this.isCreatingInlineRound) {
                  <div
                    class="fade-in rounded absolute inset-0 bg-black/50 flex items-center justify-center"
                  >
                    <app-loader />
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Détail de la tournée - 3/4 de la page -->
        <div class="flex-1 flex flex-col overflow-hidden">
          @if (selectedRounds.length > 0) {
            <!-- Affichage des tournées sélectionnées côte à côte -->
            <div class="flex-1 flex overflow-hidden gap-4 p-4">
              @for (round of selectedRounds; track round.id; let i = $index) {
                <div
                  class="select-none flex-1 flex flex-col overflow-hidden rounded shadow"
                  [class.display-round-first]="i === 0"
                  [class.display-round-second]="i === 1"
                >
                  <div
                    class="p-6 header text-white w-full flex items-center gap-3"
                  >
                    <span class="w-2 h-2 bg-white rounded-full"></span>
                    <h2 class="text-xl font-semibold -mt-1">
                      {{ round.name }}
                    </h2>
                  </div>

                  <div
                    class="flex-1 overflow-y-auto p-6 border-l border-r border-b border-gris-3 bg-gris-4 relative"
                  >
                    <!-- Indicateur visuel de drop en haut -->
                    @if (
                      dropIndicator?.roundId === round.id &&
                      dropIndicator?.position === 'top'
                    ) {
                      <div
                        class="absolute top-0 left-0 right-0 h-1 bg-blue-500 z-10 animate-pulse pointer-events-none"
                      ></div>
                      <div
                        class="absolute top-6 left-6 right-6 bg-blue-100 border-2 border-blue-400 border-dashed rounded-lg p-3 z-10 flex items-center justify-center pointer-events-none"
                      >
                        <span class="text-sm font-medium text-blue-700">{{
                          'delivery_round.drop_first_position' | translate
                        }}</span>
                      </div>
                    }

                    <!-- Indicateur visuel de drop en bas -->
                    @if (
                      dropIndicator?.roundId === round.id &&
                      dropIndicator?.position === 'bottom'
                    ) {
                      <div
                        class="absolute bottom-0 left-0 right-0 h-1 bg-blue-500 z-10 animate-pulse pointer-events-none"
                      ></div>
                      <div
                        class="absolute bottom-6 left-6 right-6 bg-blue-100 border-2 border-blue-400 border-dashed rounded-lg p-3 z-10 flex items-center justify-center pointer-events-none"
                      >
                        <span class="text-sm font-medium text-blue-700">{{
                          'delivery_round.drop_last_position' | translate
                        }}</span>
                      </div>
                    }

                    <!-- Contenu du détail de la tournée -->
                    <div
                      class="space-y-4 pb-4 pt-4 min-h-full"
                      (dragover)="onContainerDragOver($event, round.id)"
                      (dragleave)="onContainerDragLeave($event, round.id)"
                      (drop)="onContainerDrop($event, round.id)"
                    >
                      @if (round.households.length === 0) {
                        <div
                          class="flex items-center justify-center h-64 text-gray-400 border-2 border-dashed border-gray-300 rounded-lg"
                        >
                          <div class="text-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="w-16 h-16 mx-auto mb-2 opacity-50"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
                              />
                            </svg>
                            <p class="text-sm font-medium">
                              {{
                                'delivery_round.no_household_in_round'
                                  | translate
                              }}
                            </p>
                            @if (draggedHousehold) {
                              <p class="text-xs mt-2 text-blue-500">
                                {{
                                  'delivery_round.drop_household_here'
                                    | translate
                                }}
                              </p>
                            }
                          </div>
                        </div>
                      }

                      @for (
                        household of round.households;
                        track household.id;
                        let j = $index
                      ) {
                        <item-delivery-round-household
                          [household]="household"
                          [position]="j"
                          [color]="i === 0 ? 'bleu' : 'rose'"
                          [isFirst]="j === 0"
                          [isLast]="j === round.households.length - 1"
                          [totalHouseholds]="round.households.length"
                          (dragStarted)="
                            onHouseholdDragStart(
                              $event.household,
                              $event.position,
                              round.id
                            )
                          "
                          (dragEnded)="onHouseholdDragEnd()"
                          (dropped)="
                            onHouseholdDropped(
                              $event.household,
                              $event.targetPosition,
                              round.id
                            )
                          "
                          (positionChanged)="
                            onHouseholdPositionChanged(
                              $event.household,
                              $event.targetPosition,
                              round.id
                            )
                          "
                        />
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="flex-1 flex items-center justify-center fg-gris-1">
              <div class="text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-10 mb-2 mx-auto"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                    clip-rule="evenodd"
                  />
                </svg>

                <p class="text-lg w-64">
                  {{ 'delivery_round.select_to_view_details' | translate }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div class="flex-1 flex items-center justify-center p-6">
      <app-loader />
    </div>
  }
</div>

@if (isLoadingPreview) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <app-loader />
  </div>
}

@if (optimisePreview) {
  <modal-optimise-preview
    [preview]="optimisePreview"
    (onCancel)="closeOptimisePreview()"
    (onConfirm)="confirmOptimisePreview()"
  />
}

@if (isApplyingOptimise) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <app-loader />
  </div>
}
